export const defaultIcon =
  'https://filestorage.api.tplus.io/file/b677ff50-327c-445a-8636-56f0f8d8c97c/public';

export const small = 25;
export const medium = 35;
export const large = 45;
